module.exports = __webpack_public_path__ + "img/log.51b5ad63.png";